import {ActiveModules} from '../services/active-modules/active-modules.enum';
import {Injectable} from '@angular/core';
@Injectable()
export class ActiveModuleHandler {
  public isValidModule(modules: ActiveModules, module: ActiveModules) : boolean {
    // tslint:disable-next-line:no-bitwise
    return ((modules & module) === module);
  }
}
